import FontBody3 from '../../../../../components/fonts/font-body3/font-body3';
import { FONT_COLOR } from '../../../../../components/fonts/font-props';

interface IProps {
    message: string;
    retryLabel: string;
    onRetry: () => void;
}

const RmaShopperLoadFailed: React.FC<IProps> = ({ message, retryLabel, onRetry }) => (
    <span className="rma-shopper-load-failed">
        <FontBody3 color={FONT_COLOR.PRIMARY2}>{message}</FontBody3>
        <button type="button" className="rma-shopper-retry-button" onClick={onRetry}>
            <FontBody3 color={FONT_COLOR.ACCENT1}>{retryLabel}</FontBody3>
        </button>
    </span>
);

export default RmaShopperLoadFailed;
